export function Spinner({ size = 'md' }: { size?: 'sm' | 'md' | 'lg' }) {
  const dim = { sm: 'h-4 w-4', md: 'h-6 w-6', lg: 'h-10 w-10' }[size]
  return (
    <div
      className={`${dim} animate-spin rounded-full border-2 border-gray-600 border-t-accent-blue`}
    />
  )
}
